import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule, RouterComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { GoogleChartsModule } from 'angular-google-charts';
import { Pipe, PipeTransform } from '@angular/core';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from "ngx-spinner";
import { JwPaginationModule } from 'jw-angular-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import '@amcharts/amcharts4/charts';
import '@amcharts/amcharts4/maps';

// components
import { SubNavbarComponent } from './components/sub-navbar/sub-navbar.component';
import { TabHomeComponent } from './components/tab-home/tab-home.component';

// coop
import { CoopComponent } from './pages/Coop/coop/coop.component';
import { CoopInfoComponent } from './pages/Coop/coop-info/coop-info.component';
import { CoopAssetsComponent } from './pages/Coop/coop-assets/coop-assets.component';
import { LoginComponent } from './pages/Authen/login/login.component';
import { CoopMachineComponent } from './pages/Coop/coop-machine/coop-machine.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavLogoComponent } from './components/nav-logo/nav-logo.component';
import { ButtonComponent } from './components/button/button.component';
import { ArrowComponent } from './components/arrow/arrow.component';
import { RatingComponent } from './components/rating/rating.component';
import { TabComponent } from './components/tab/tab.component';
import { CoopInsertComponent } from './pages/Coop/coop-insert/coop-insert.component';
import { CoopProfileComponent } from './pages/Coop/coop-profile/coop-profile.component';
import { CmsHomeComponent } from './pages/cms/cms-home/cms-home.component';
import { CmsSideBarComponent } from './components/cms-side-bar/cms-side-bar.component';
import { CmsTopBarComponent } from './components/cms-top-bar/cms-top-bar.component';
import { UserManagementComponent } from './pages/cms/user-management/user-management.component';
import { SatisfactionManagementComponent } from './pages/cms/satisfaction-management/satisfaction-management.component';
import { PageManagementComponent } from './pages/cms/page-management/page-management.component';
import { CreateUserComponent } from './pages/cms/user-management/create-user/create-user.component';
import { EditUserComponent } from './pages/cms/user-management/edit-user/edit-user.component';
import { HomeAgriComponent } from './pages/home-agri/home-agri.component';
import { AgriInfoComponent } from './pages/agri/agri-info/agri-info.component';
import { AgriInsertComponent } from './pages/agri/agri-insert/agri-insert.component';
import { AgriAssetsComponent } from './pages/agri/agri-assets/agri-assets.component';
import { AgriMachineComponent } from './pages/agri/agri-machine/agri-machine.component';
import { AgriProfileComponent } from './pages/agri/agri-profile/agri-profile.component';

@NgModule({
  declarations: [
    RouterComponents,
    AppComponent,
    CoopInfoComponent,
    SubNavbarComponent,
    TabHomeComponent,
    CoopComponent,
    CoopAssetsComponent,
    LoginComponent,
    CoopMachineComponent,
    FooterComponent,
    NavLogoComponent,
    ButtonComponent,
    ArrowComponent,
    RatingComponent,
    TabComponent,
    CoopInsertComponent,
    CoopProfileComponent,
    CmsHomeComponent,
    CmsSideBarComponent,
    CmsTopBarComponent,
    UserManagementComponent,
    SatisfactionManagementComponent,
    PageManagementComponent,
    CreateUserComponent,
    EditUserComponent,
    HomeAgriComponent,
    AgriInfoComponent,
    AgriInsertComponent,
    AgriAssetsComponent,
    AgriMachineComponent,
    AgriProfileComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FontAwesomeModule,
    AppRoutingModule,
    NgSelectModule,
    HttpClientModule,
    Ng2SearchPipeModule,
    FormsModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    JwPaginationModule

  ],
  exports: [
  ],
  providers: [
    Location, {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
